import { Route, Routes } from "react-router";
import NotFoundPage from "./NotFoundPage";
import Home from "./Home";
import WebFeatures from "./WebFeatures";
import WebSubscription from "./WebSubscription";
import AboutUs from "./AboutUs";
import KnowledgeBase from "./KnowledgeBase";
import Blog from "./Blog";
import DemoRequest from "./DemoRequest";
import BlogSingle from "./BlogSingle";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsCondition from "./TermsCondition";
import ChangeLog from "./ChangeLog";
import WebFaq from "./WebFaq";
import Addons from "./Addons";
import AddonsDetails from "./AddonsDetails";
import OfferPage from "./OfferPage";
import OfferDetails from "./OfferDetails";
import OfferDetails2 from "./OfferDetails2";
import OrderRequest from "./OrderRequest";
import ChangeLogDetails from "./ChangeLogDetails";

const RoutePage = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/webfeature" element={<WebFeatures />} />
        <Route path="/websubscription" element={<WebSubscription />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/knowledgebase" element={<KnowledgeBase />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogsingle" element={<BlogSingle />} />
        <Route path="/demorequest" element={<DemoRequest />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termscondition" element={<TermsCondition />} />
        <Route path="/changelog" element={<ChangeLog />} />
        <Route path="/webfaq" element={<WebFaq />} />
        <Route path="/addons" element={<Addons />} />
        <Route path="/addondetails" element={<AddonsDetails />} />
        <Route path="/offerpage" element={<OfferPage />} />
        <Route path="/offerdetails" element={<OfferDetails />} />
        <Route path="/offerdetails2" element={<OfferDetails2 />} />
        <Route path="/orderrequest" element={<OrderRequest />} />
        <Route path="/changelogdetails" element={<ChangeLogDetails />} />
      </Routes>
    </>
  );
};

export default RoutePage;
